function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#B52929"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6038 12.6039C12.7399 12.4676 12.9016 12.3595 13.0795 12.2857C13.2575 12.2119 13.4482 12.174 13.6409 12.174C13.8335 12.174 14.0243 12.2119 14.2022 12.2857C14.3801 12.3595 14.5418 12.4676 14.6779 12.6039L20.0001 17.9242L25.3223 12.6039C25.4585 12.4678 25.6202 12.3597 25.7981 12.286C25.9761 12.2123 26.1668 12.1744 26.3594 12.1744C26.552 12.1744 26.7427 12.2123 26.9206 12.286C27.0986 12.3597 27.2603 12.4678 27.3964 12.6039C27.5326 12.7401 27.6407 12.9018 27.7144 13.0797C27.7881 13.2577 27.826 13.4484 27.826 13.641C27.826 13.8336 27.7881 14.0243 27.7144 14.2022C27.6407 14.3802 27.5326 14.5419 27.3964 14.678L22.0762 20.0003L27.3964 25.3225C27.6715 25.5975 27.826 25.9705 27.826 26.3595C27.826 26.7485 27.6715 27.1215 27.3964 27.3966C27.1214 27.6716 26.7484 27.8261 26.3594 27.8261C25.9704 27.8261 25.5974 27.6716 25.3223 27.3966L20.0001 22.0763L14.6779 27.3966C14.4029 27.6716 14.0298 27.8261 13.6409 27.8261C13.2519 27.8261 12.8789 27.6716 12.6038 27.3966C12.3288 27.1215 12.1743 26.7485 12.1743 26.3595C12.1743 25.9705 12.3288 25.5975 12.6038 25.3225L17.9241 20.0003L12.6038 14.678C12.4675 14.5419 12.3594 14.3803 12.2856 14.2023C12.2118 14.0244 12.1738 13.8336 12.1738 13.641C12.1738 13.4484 12.2118 13.2576 12.2856 13.0797C12.3594 12.9017 12.4675 12.7401 12.6038 12.6039Z",
  fill: "white"
});
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.235bde228c2610e5a5f9d762095a9698.svg";
export { ForwardRef as ReactComponent };